/*
 * @Author: Json Chen
 * @Date: 2021-07-14 15:41:12
 * @LastEditTime: 2021-10-13 14:24:58
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/CourierAccount/tools.ts
 */

import { locationList } from './config';
import { CourierType } from './type';
// 请求时 提交的Type
export const transformTypeReq = (type) => {
  switch (type) {
    case CourierType.SF:
      return 'QSF';
    case CourierType.ZTO:
      return 'ZTO';
    default:
      return '';
  }
};

// 获取后台结果,拿到前端对应的类型
export const transformTypeRes = (type) => {
  switch (type) {
    case 'QSF':
      return CourierType.SF;
    case 'ZTO':
      return CourierType.ZTO;
    default:
      return '';
  }
};

// 列表中展示的文字 format
export const getCourierShow = (c) => {
  switch (c.type) {
    case 'QSF':
      const { label: location = '' } =
        locationList.find((l) => l.value === c.qsfAccount.location) || {};

      return `SF Express${location ? ` - ${location}` : ''}`;

    case 'ZTO':
      return `ZTO International`;
  }
};
